module.exports = __webpack_public_path__ + "img/Belgravia-Standard.6bfcc3e0.png";